import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Index.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
      },
      {
        path: '/buy-car',
        name: 'BuyCar',
        component: () => import(/* webpackChunkName: "Home" */ '../views/BuyCar.vue')
      },
      {
        path: '/custom-page',
        name: 'CustomPage',
        component: () => import(/* webpackChunkName: "Home" */ '../views/CustomPage.vue')
      },
      {
        path: '/vehicle-contrast',
        name: 'VehicleContrast',
        component: () => import(/* webpackChunkName: "Home" */ '../views/VehicleContrast.vue')
      },
      {
        path: '/sell-car',
        name: 'SellCar',
        component: () => import(/* webpackChunkName: "Home" */ '../views/SellCar.vue')
      },
      {
        path: '/news',
        name: 'News',
        component: () => import(/* webpackChunkName: "Home" */ '../views/News.vue')
      },
      {
        path: '/car-detail',
        name: 'CarDetail',
        component: () => import(/* webpackChunkName: "Home" */ '../views/CarDetail.vue')
      },
      {
        path: '/news-detail',
        name: 'NewsDetail',
        component: () => import(/* webpackChunkName: "Home" */ '../views/NewsDetail.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
